import { createContext, useContext, useMemo, useRef, useState } from "react";
import JoditEditor from "jodit-react";

export const JoditEditorContext = createContext();

export const JoditEditorProvider = ({ children }) => {
  const editorRef = useRef(null);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  const values = useMemo(
    () => ({
      editorRef,
      content,
      setContent,
      loading,
      setLoading,
    }),
    [content, loading]
  );

  return (
    <JoditEditorContext.Provider value={values}>
      {loading ? <p>Loading Editor...</p> : children}
    </JoditEditorContext.Provider>
  );
};

// Custom Hook to use the context
export const useJoditEditor = () => {
  const context = useContext(JoditEditorContext);
  if (!context) {
    throw new Error("useJoditEditor must be used within JoditEditorProvider");
  }
  return context;
};
